export default "__VITE_ASSET__b123f07d__"